import { Box, Card, CardHeader } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import colors from '../../constants/colors'
import { ICardTAG } from './types'
import RemoveButton from '../RemoveButton'

const CardTAG: FC<ICardTAG> = ({
  children,
  title,
  boxError,
  closable = false,
  closeCard,
  cardAction,
  color = 'tagBoxSuccess',
  className = '',
  childrenContainerStyle = {},
  questionCard = false,
}) => {
  const [type, setType] = useState(color)
  useEffect(() => {
    if (boxError) {
      setType('tagBoxError')
      return
    }
    setType(color)
  }, [boxError])

  const cardHeaderStyle = {
    display: 'flex',
    py: '0px',
    px: '0px',
    borderBottom: children ? 1 : 0,
    borderColor: `${type}.border`,
    justifyContent: 'space-between',
    textAlign: 'left',
    backgroundColor: `${type}.background`,
    color: `${type}.text`,
    maxWidth: '100%',
  }

  return (
    <Card
      elevation={0}
      className={`t-card-tag ${className}`}
      sx={{ border: 1, borderColor: `${type}.border`, backgroundColor: colors.WHITE }}
    >
      <CardHeader
        titleTypographyProps={{ typography: 'h3' }}
        className='t-card-header'
        sx={{
          ...cardHeaderStyle,
        }}
        title={
          <Box
            sx={{
              py: '18px',
              px: '36px',
              textOverflow: 'ellipsis',
              ...(!questionCard
                ? { overflow: 'hidden', whiteSpace: 'nowrap' }
                : { whiteSpace: 'unset !important' }),
            }}
          >
            {title}
          </Box>
        }
        action={
          <>
            {cardAction && cardAction}
            {closable && (
              <RemoveButton tooltipMessage='Close Card' removeFunctionHandler={closeCard} />
            )}
          </>
        }
      />
      {children && (
        <Box className={'t-card-tag-body'} sx={{ ...childrenContainerStyle }}>
          {children}
        </Box>
      )}
    </Card>
  )
}

export default CardTAG
